export class ChangeMethodInputDto {
    // não grava nada: devolve o que aconteceria, para a tela avisar antes de confirmar
    simulation?: boolean
    // só 'pix' ou 'bankslip'. cartão fica de fora: exigiria o titular informar os dados de novo
    method: string
}

export class ChangeMethodOutputDto {
    simulation: boolean
    fromMethod: string
    toMethod: string
    purchaseType: string
    // parcelas ainda não enviadas: são estas que passam a cobrar pelo meio novo
    chargesToChange: { chargeId: string; dueDate: Date; value: number }[]
    // cobranças já emitidas e ainda pagáveis pelo meio anterior — nunca canceladas no gateway
    openAtPreviousMethod: { chargeId: string; dueDate: Date; paymentMethod: string }[]
}
